import { createSlice, createAction } from "@reduxjs/toolkit"

const initialState = {
  suitability: null, // [id]: { url: string, replace: boolean, dispatchAction: { type, payload } }
}

const slice = createSlice({
  initialState,
  name: "redirect",
  reducers: {
    setRedirectUrl: (state, { payload: { id, ...payload } }) => {
      state[id] = payload
    },
    clearRedirectUrl: (state, { payload: id }) => {
      state[id] = null
    },
  },
})

export const redirect = createAction(`${slice.name}/redirectTask`)
export const {
  setRedirectUrl,
  clearRedirectUrl,
} = slice.actions

export default slice